import React, { useState } from "react";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";
import Section from "./Section";
import Modal from "../Modal/Modal";
import Button from "../Form/Button/Button";
import Checkbox from '../Form/Checkbox/Checkbox';

/** @import {MyProfile} from './MyProfileTypes' */

const UPDATE_PREFERENCES = gql`
  mutation updateMarketingPreferences(
    $request: UpdateMarketingPreferencesRequestType!
  ) {
    updateMarketingPreferences(request: $request) {
      success
    }
  }
`;

function MarketingPreference(/** @type {{ profile: MyProfile }} */ { profile: { marketingPreference } }) {
  const [updateMarketingPreferences] = useMutation(UPDATE_PREFERENCES);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [initialState, setInitialState] = useState({
    phone: marketingPreference.phone,
    email: marketingPreference.email,
    online: marketingPreference.onlineBankingMessaging,
  });
  const [marketingPreferenceState, setMarketingPreferences] = useState({
    phone: marketingPreference.phone,
    email: marketingPreference.email,
    online: marketingPreference.onlineBankingMessaging,
  });

  const startEditing = () => {
    setInitialState(marketingPreferenceState);
    setEditing(true);
  };

  const cancelEditing = () => {
    setMarketingPreferences(initialState);
    saveCancelledChanges()
  };

  const updatePreference = (/** @type {string} */ channel) => (/** @type {boolean} */ value) => {
    let newState = { ...marketingPreferenceState, [channel]: value };
    setMarketingPreferences(newState);
  };

  const saveChanges = async () => {
    const result = await updateMarketingPreferences({
      variables: {
        request: marketingPreferenceState,
      },
    });

    if (result.data.updateMarketingPreferences.success) {
      setSuccessModalOpen(true);
    }
    setEditing(false);
  };

  const saveCancelledChanges = async () => {
    await updateMarketingPreferences({
      variables: {
        request: marketingPreferenceState,
      },
    });

    setEditing(false);
  };

  const onModalComplete = () => {
    setSuccessModalOpen(false);
  };

  const renderSuccessModal = () => {
    return (
      <Modal
        onClose={onModalComplete}
        className="modal--fixed-height"
        ignoreClickOutside={true}
      >
        <>
          <h4 className="modal__success-title">Success!</h4>
          <p className="modal__paragraph">
            Your marketing preferences have been updated.
          </p>
          <div className="modal__spacer" />
          <Button size='med'
            customClassNames={["modal__button", "modal__button--left"]}
            label="Done"
            onClick={onModalComplete}
          />
        </>
      </Modal>
    );
  };

  return (
    <>
      <Section
        title="Marketing preference"
        editing={editing}
        setEditing={startEditing}
        onCancel={cancelEditing}
        onSave={saveChanges}
        validation={() => true}
        modifiers={['toggle-width']}
        valid={true}
      >
        <div className="my-profile__marketing-toggles">
          <div className="my-profile__toggle">
            <Checkbox
              className="email__checkbox"
              label="Email"
              onChange={updatePreference("email")}
              checked={marketingPreferenceState.email}
              disabled={!editing}
            />
          </div>
          <div className="my-profile__toggle">
            <Checkbox
              className="phone__checkbox"
              label="Text message"
              onChange={updatePreference("phone")}
              checked={marketingPreferenceState.phone}
              disabled={!editing}
            />
          </div>
          <div className="my-profile__toggle">
            <Checkbox
              className="online__checkbox"
              label="Online banking messaging"
              onChange={updatePreference("online")}
              checked={marketingPreferenceState.online}
              disabled={!editing}
            />
          </div>
        </div>
        {successModalOpen && renderSuccessModal()}
      </Section>
    </>
  );
};

export default MarketingPreference;
